// extracted by mini-css-extract-plugin
module.exports = {"content":"DiscloseText_content__wpgH_","shadow":"DiscloseText_shadow__gOX42","button":"DiscloseText_button__k1xdE","open":"DiscloseText_open__Fcf3F"};